import actions from '@/store/modules/annotation-group/actions.js'
import mutations from '@/store/modules/annotation-group/mutations.js'
import getters from '@/store/modules/annotation-group/getters.js'
import {base_state} from '@/store/modules/base/state.js'

const state = {
  ...base_state,
  'api_module': 'annotation_group'
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}